export default "__VITE_ASSET__Cox74CYf__"